if (window.user && window.fcWidget) {
  window.fcWidget.setExternalId(window.user.firebase_user_id);
  window.fcWidget.user.setEmail(window.user.email);
}
